module.exports = __webpack_public_path__ + "img/chatillon.c2bc87a1.jpg";